
import { observable, action, runInAction } from "mobx";
import * as API from '../../../../api/m/feedback'
import { Dialog } from "@weapp/ui";
import { getLabel } from "@weapp/utils";
const { message } = Dialog;

class MFeedbackStore {
    @action
    commitFeedback = (text: string) => {
        API.commitFeedback(text)
            .then((result: any) => {
                runInAction(() => {
                    message({
                        type: "success",
                        content: getLabel('62288', "感谢您的宝贵意见!"),
                    });
                    const delayTimer = setTimeout(() => {
                        window.history.go(-1);
                        clearTimeout(delayTimer);
                    }, 500)
                });
            })
            .catch((error: any) => {
                console.log(error);
            });
    }
}

const instance = new MFeedbackStore();

export default instance;
